/*
 * Copyright (c) Nexign, JSC, 2021-2023.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @author Ilya Babanov
 * @version 1.23.0
 * @since 1.14.0
 */

import { createAction } from '../app/createAction';
import {
  FORM_ADDRESS_GET_AS_STRING_FAILURE,
  FORM_ADDRESS_GET_AS_STRING_START,
  FORM_ADDRESS_GET_AS_STRING_SUCCESS,
  FORM_ADDRESS_INITIALIZE,
  FORM_ADDRESS_SEARCH_FAILURE,
  FORM_ADDRESS_SEARCH_START,
  FORM_ADDRESS_SEARCH_SUCCESS,
} from './constant/formAddressConstants';
import type {
  IAddressStringPayload,
  IFormAddressAddressPayload,
  IFormAddressGetAsStringSuccessPayload,
  IFormAddressSearchStartPayload,
  IFormAddressSearchSuccessPayload,
  TFormAddressGetAsStringFailureAction,
  TFormAddressGetAsStringStartAction,
  TFormAddressGetAsStringSuccessAction,
  TFormAddressInitializeAction,
  TFormAddressSearchFailureAction,
  TFormAddressSearchStartAction,
  TFormAddressSearchSuccessAction,
} from './types/formAddressActionTypes';

/*
 * -------------------------------------------
 *       Form Initialize
 * -------------------------------------------
 */

export const formAddressInitializeAction = (
  payload: IFormAddressAddressPayload,
): TFormAddressInitializeAction =>
  createAction(FORM_ADDRESS_INITIALIZE, payload);

/*
 * -------------------------------------------
 *       Search for Address Matches
 * -------------------------------------------
 */

export const formAddressSearchStartAction = (
  payload: IFormAddressSearchStartPayload,
): TFormAddressSearchStartAction =>
  createAction(FORM_ADDRESS_SEARCH_START, payload);

export const formAddressSearchSuccessAction = (
  payload: IFormAddressSearchSuccessPayload,
): TFormAddressSearchSuccessAction =>
  createAction(FORM_ADDRESS_SEARCH_SUCCESS, payload);

export const formAddressSearchFailureAction = (
  payload: string,
): TFormAddressSearchFailureAction =>
  createAction(FORM_ADDRESS_SEARCH_FAILURE, payload);

/*
 * -------------------------------------------
 *       Get Address as String
 * -------------------------------------------
 */

export const formAddressGetAsStringStartAction = (
  payload: IAddressStringPayload,
): TFormAddressGetAsStringStartAction =>
  createAction(FORM_ADDRESS_GET_AS_STRING_START, payload);

export const formAddressGetAsStringSuccessAction = (
  payload: IFormAddressGetAsStringSuccessPayload,
): TFormAddressGetAsStringSuccessAction =>
  createAction(FORM_ADDRESS_GET_AS_STRING_SUCCESS, payload);

export const formAddressGetAsStringFailureAction = (
  payload: string,
): TFormAddressGetAsStringFailureAction =>
  createAction(FORM_ADDRESS_GET_AS_STRING_FAILURE, payload);
